import React from 'react';
import ZProps from './zprops';
import ZUtil from './zutil';
import AMC from './AMC';
import { APP } from './App';

export default class FreakoutButton extends React.Component {
	constructor(props) {
		super(props);
		this.state = { item: this.props.item };
	}
	onFreakout() {
		let { item } = this.state;
		AMC.activity(item, "freakout");
		APP.showPopup(<ZooFreakingOut item={item} />, "rgba(0,0,0,0.9)")
		item.freakouts = (item.freakouts || 0) + 1;
		this.setState({ item: item });
	}
	render() {
		let {item } = this.state;
		return (
			<div className="HScoreButton" onClick={this.onFreakout.bind(this)}>
			<div className="HScoreButtonLabel" aria-label="I'm freaking out" title={"Freaking out here"}>
				<img alt="freaking out" className="HScoreButtonIcon" src="/images/freak.png" />
				I'm Freaking Out
			</div>
			<div className="HScoreButtonCount" aria-label={item.freakouts + " people were freaking out."}>{item.freakouts || 0}</div>
			</div>
		)
	}
}
class ZooFreakingOut extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		let freakouts = ZProps.get("freakout");
		let freakout = ZUtil.randomElement(freakouts.list);
		return (
			<div className="ZooFreakingOut CENTERED" dangerouslySetInnerHTML={{ __html: freakout }}></div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/FreakoutButton.js